module.exports = __webpack_public_path__ + "img/new.29d2ba26.jpg";